import { Button, Modal } from "components";
import { FC } from "react";
import { CiCircleRemove, CiWarning } from "react-icons/ci";
import { MdCheckCircle } from "react-icons/md";
import { TbExclamationCircle } from "react-icons/tb";
import { useTheme } from "styled-components";
import { IConfirmationModalProps } from "./types";

export const ConfirmationModal: FC<IConfirmationModalProps> = ({
  onClose,
  onConfirm,
  title,
  type = "success",
  confirmText = "بله",
  cancelText = "خیر",
  confirmButtonColorType,
  closeButtonColorType,
  confirmButtonVariant = "primary",
  closeButtonVariant = "outlined",
  size = "sm",
  isLoading = false,
  className,
  children,
}) => {
  const { colors } = useTheme();
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={
        type === "success"
          ? "موفقیت آمیز"
          : type === "error"
            ? "خطا"
            : type === "info"
              ? "راهنما"
              : "اخطار"
      }
      className={className}
      size={size}
    >
      <div>
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center mt-2 text-center">
          {type === "success" ? (
            <MdCheckCircle
              style={{ color: colors.background.successLight }}
              size={70}
            />
          ) : type === "error" ? (
            <CiCircleRemove
              style={{ color: colors.background.errorLight }}
              size={70}
            />
          ) : type === "info" ? (
            <TbExclamationCircle
              style={{ color: colors.background.successLight }}
              size={70}
            />
          ) : (
            <CiWarning
              style={{ color: colors.background.warningLight }}
              size={70}
            />
          )}

          <p className="my-3" style={{ fontSize: 20 }}>
            {title}
          </p>
          {children}
        </div>
        <div className="d-flex align-items-center mt-4 gap-2 ">
          <Button
            colorType={confirmButtonColorType}
            variant={confirmButtonVariant}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {confirmText}
          </Button>
          <Button
            colorType={closeButtonColorType}
            variant={closeButtonVariant}
            onClick={onClose}
          >
            {cancelText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
